import { render } from "./ShippingBillUpload.vue?vue&type=template&id=ee1df858&scoped=true"
import script from "./ShippingBillUpload.vue?vue&type=script&lang=js"
export * from "./ShippingBillUpload.vue?vue&type=script&lang=js"

import "./ShippingBillUpload.vue?vue&type=style&index=0&id=ee1df858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee1df858"]])

export default __exports__